import '.dm{padding-top:222px;}.ssr-plugin'
import '.bj{padding-bottom:96px;}.ssr-plugin'
import '.bk{padding-left:96px;}.ssr-plugin'
import '.bi{padding-right:96px;}.ssr-plugin'
import '.o{display:flex;}.ssr-plugin'
import '.p{flex-direction:column;}.ssr-plugin'
import '.v{align-items:center;}.ssr-plugin'
import '.bb{justify-content:center;}.ssr-plugin'
import '.aw{text-align:center;}.ssr-plugin'
import '.az{min-height:100dvh;}.ssr-plugin'
import '.ag{box-sizing:border-box;}.ssr-plugin'
import '.f{flex:1;}.ssr-plugin'
import '.b0{max-width:1280px;}.ssr-plugin'
import '.a{width:100%;}.ssr-plugin'
import { styled, Style } from 'inlines'
import { MOBILE, TABLET } from '../utils/breakpoints.js'

type LayoutProps = {
  children: React.ReactNode
  style?: Style
}

export const Layout = ({ children, style }: LayoutProps) => {
  return (
    <styled.div className="dm bj bk bi o p v bb aw az ag f"
      style={{
        [TABLET]: {
          paddingTop: '158px',
          paddingLeft: '48px',
          paddingRight: '48px',
        },
        [MOBILE]: {
          paddingLeft: '16px',
          paddingRight: '16px',
        },
        ...style,
      }}
    >
      <div className="b0 a o p v bb aw"
      >
        {children}
      </div>
    </styled.div>
  )
}
